import { render, staticRenderFns } from "./OfficerPage.vue?vue&type=template&id=578cb710&"
import script from "./js/officer-page.js?vue&type=script&lang=js&"
export * from "./js/officer-page.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports